export const INTEGRATION_NAMES = {
  SYNERGETIC: "SYNERGETIC",
  SENTRAL: "SENTRAL",
  ENGAGE: "ENGAGE",
  SCHOOLEDGE: "SCHOOLEDGE",
  SCHOOLPRO: "SCHOOLPRO",
  PCSCHOOL: "PCSCHOOL",
  TASS: "TASS",
  EDUMATE: "EDUMATE",
};

export const INTEGRATION_LABELS = {
  SYNERGETIC: "Synergetic",
  SENTRAL: "Sentral",
  ENGAGE: "Engage",
  SCHOOLEDGE: "SchoolEdge",
  SCHOOLPRO: "SchoolPro",
  PCSCHOOL: "PCSchool",
  TASS: "TASS",
  EDUMATE: "Edumate API",
};

export const SCHEDULED_SYNC_STATUS = {
  NOT_PROCESSED: "not_processed",
  PROCESSED: "processed",
  CANCELLED: "cancelled",
  ERROR: "error",
};

export const SCHEDULED_SYNC_STATUS_OPTIONS = [
  { value: SCHEDULED_SYNC_STATUS.NOT_PROCESSED, text: "Not Processed" },
  { value: SCHEDULED_SYNC_STATUS.PROCESSED, text: "Processed" },
  { value: SCHEDULED_SYNC_STATUS.CANCELLED, text: "Cancelled" },
  { value: SCHEDULED_SYNC_STATUS.ERROR, text: "Processed with error" },
];

export const SCHEDULED_SYNC_DIRECTION = {
  PUSH_ALL: "PUSH_ALL",
  PUSH_DOCS: "PUSH_DOCS",
  PULL_ALL: "PULL_ALL",
};

export const SCHEDULED_SYNC_DIRECTION_HELP_REFERENCES = {
  [SCHEDULED_SYNC_DIRECTION.PUSH_ALL]: "scheduled_sync_push_all",
  [SCHEDULED_SYNC_DIRECTION.PUSH_DOCS]: "scheduled_sync_push_docs",
  [SCHEDULED_SYNC_DIRECTION.PULL_ALL]: "scheduled_sync_pull_all",
};

export const SCHEDULED_SYNC_FEATURES = {
  DEFAULT_SYNC: "DEFAULT_SYNC",
  PUSH_ALL: "PUSH_ALL",
  PUSH_DOCS: "PUSH_DOCS",
  PULL_ALL: "PULL_ALL",
  CANCEL: "CANCEL",
};

export const getScheduledSyncDirectionOptions = (systemNameLabel) => {
  return [
    {
      value: SCHEDULED_SYNC_DIRECTION.PUSH_ALL,
      text: `Schedule push all to ${systemNameLabel}`,
    },
    {
      value: SCHEDULED_SYNC_DIRECTION.PUSH_DOCS,
      text: `Schedule push docs to ${systemNameLabel}`,
    },
    {
      value: SCHEDULED_SYNC_DIRECTION.PULL_ALL,
      text: `Schedule pull from ${systemNameLabel}`,
    },
  ];
};
